export const DATA_TYPE_MAP = {
  BOOLEAN: 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery',
  FLOAT: 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery',
  LONG: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery',
  STRING: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery'
};
export function mapSortForRpc(sort) {
  switch (sort) {
    case 'MOST_INSTALLED':
      return [{
        field: 'INSTALL_COUNT',
        order: 'DESC'
      }];
    case 'NEWEST':
      return [{
        field: 'FIRST_PUBLISHED_AT',
        order: 'DESC'
      }];
    case 'NAME_AZ':
      return [{
        field: 'LISTING_NAME',
        order: 'ASC'
      }];
    case 'NAME_ZA':
      return [{
        field: 'LISTING_NAME',
        order: 'DESC'
      }];
    default:
      return undefined;
  }
}
export function mapAppliedFiltersForRpc(filters) {
  const filtersByField = {};
  for (const filter of filters) {
    filtersByField[filter.field] = [{
      values: parseAppliedFilterValues(filter),
      clause: 'OR',
      negation: false,
      __typename: DATA_TYPE_MAP[filter.dataType]
    }];
  }
  return {
    filterGroups: [{
      filtersByField,
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
}
export function parseAppliedFilterValues(filter) {
  switch (filter.dataType) {
    case 'BOOLEAN':
      return filter.values.map(value => value === 'true');
    case 'LONG':
    case 'FLOAT':
      return filter.values.map(Number);
    default:
      return filter.values;
  }
}